
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import imagePhoto from 'assets/icons/icon_photo@3x.png'
import { mapState, mapActions } from 'vuex'
import { QINIU_SERVER } from '../../config'

import Long from 'long'

export default {
name: 'TalentRaiders',
components: {
XHeader,
Flexbox,
FlexboxItem,
Swiper,
Previewer,
XImg,
},
data() {
return {

swiper_index: 0,
imagePhoto,
imgList: [],
current: 0,
}
},
computed: {
advImage() {
if (this.ads.length > 0) {
const ads = this.ads.map(ad => ({
img: `${QINIU_SERVER}${ad.img}`,
url: this.getAdUrl(ad),
}))
return ads[0]
}
return {
img: null,
url: null,
}
},
swiperList() {
if (this.ads.length > 0) {
const ads = this.ads.map(ad => ({
img: `${QINIU_SERVER}${ad.img}`,
url: this.getAdUrl(ad),
}))
return [ads[0]]
}
return []
},
...mapState({
customRoute: ({ custom }) => custom.customRoute,
raidersList: ({ custom }) => custom.topicList,
ads: ({ adv }) => adv.custom,
}),
imgPreviewList() {
return this.imgList[this.current] || []
},
},
methods: {
...mapActions(['fetchSportsRaidersList', 'fetchAds', 'showToast', 'fetchCustomRouteById']),
onSwip(index) {
this.swiper_index = index
},
getAvatar(raiders) {
return `http://qn.saiday.com/${raiders.createUser.avatar}`
},
getImage(image) {
return `http://qn.saiday.com/${image}-c.share.thumb.jpg`
},
getAdUrl(ad) {
switch (ad.adType) {
case 1:
return `/match/${ad.targetId}`
case 3:
return `/route/${ad.targetId}`
case 4:
return `/header/search?q=${ad.keyword}`
case 5:
return `/header/search?city=${ad.keyword}`
case 6:
return null
default:
return ad.url
}
},
goAdv() {
this.$router.push(this.advImage.url)
},
formatCreateDate(createDate) {

const timestamp = new Long(createDate.low, createDate.high, createDate.unsigned).toString()
const curTimestamp = new Date().getTime()
const duration = curTimestamp - timestamp
const minute = 60 * 1000
const hour = 60 * minute
const day = 24 * hour
if (duration < hour) {
return `${Math.floor(duration / minute) > 0 ? Math.floor(duration / minute) : 1}分钟前`
} else if (duration < day) {
return `${Math.floor(duration / hour) > 0 ? Math.floor(duration / hour) : 1}小时前`
}
return `${Math.floor(duration / day) > 0 ? Math.floor(duration / day) : 1}天前`
},
generateImgList() {

const containers = document.querySelectorAll('.vux-flexbox-item.right')

return Array.from(containers).map((container) => {
const image = container.querySelectorAll('img')
return Array.from(image).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || img.naturalWidth,
h: img.getAttribute('data-height') || img.naturalHeight,
}))
})
},
popUpImg(index, event) {
this.current = index

this.$nextTick(() => {
if (event.target.tagName === 'IMG') {
const idx = this.imgPreviewList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
})
},
contentLen(content) {
let count = 0
for (let i = 0; i < content.length; i += 1) {
if (content[i].codePointAt(0) > 0xffff) {
count += 2
} else {
count += 1
}
}
return count > 1000 
},
toggleRaiders(index) {
if (this.raidersList[index].unfold) {
this.raidersList[index].unfold = false
} else {
this.raidersList[index].unfold = true
}
},
},
created() {
const { sportsRouteId } = this.$route.params

this.fetchCustomRouteById({
kind: 1,
customId: sportsRouteId,
})

this.fetchSportsRaidersList(sportsRouteId).then((data) => {
this.imgList = this.generateImgList()
this.current = 0
this.raidersUnfold = data.topicList.map(() => false)
})

this.fetchAds().catch((err) => {
this.showToast(err.body.resultInfo)
})
},
}



// WEBPACK FOOTER //
// ./client/components/Custom/TalentRaiders.vue